import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.256 5.38a.67.67 0 0 1 .363.364.67.67 0 0 1-.146.73L8.94 8l1.533 1.527a.666.666 0 0 1 0 .946.665.665 0 0 1-.946 0L8 8.94l-1.527 1.533a.666.666 0 0 1-.946 0 .667.667 0 0 1 0-.946L7.06 8 5.527 6.473a.67.67 0 1 1 .946-.946L8 7.06l1.527-1.533a.67.67 0 0 1 .73-.146m.293-3.587c.814.35 1.55.857 2.164 1.494a6.667 6.667 0 1 1-9.426 9.426 6.666 6.666 0 0 1 7.262-10.92",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })